module.exports = __webpack_public_path__ + "img/cebuana.92e1ae12.png";